<i18n>
{
  "en": {
    "messages": {
    }
  },
  "ja": {
    "messages": {
    }
  }
}
</i18n>

<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" :persistent="true">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ this.title }}
        </v-card-title>

        <v-card-text xs12>
          {{ this.message }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="clickButton">
            {{ this.okButton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    clickButton: function() {
      this.$emit('click');
    }
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    okButton: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  }
};
</script>
